import { LOGOUT } from '../constants/authConstants';
import * as types from '../constants/notesConstants';

const defaultPageable = {
  totalPages: 1,
  last: true,
  first: true,
  size: 0,
  number: 0,
  totalElements: 0,
};

const defaultSearch = {
  search: '',
  page: 0,
  size: 10,
};

const initialState = {
  userNotes: [],
  publicNotes: [],
  note: null,
  selectedNote: null,
  userNotesLoading: true,
  publicNotesLoading: true,
  noteLoading: true,
  userNotesPageable: { ...defaultPageable },
  publicNotesPageable: { ...defaultPageable },
  userNotesSearch: { ...defaultSearch },
  publicNotesSearch: { ...defaultSearch },
};

const notesReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT:
      return { ...initialState };

    // user notes
    case types.CLEAR_USER_NOTES:
      return {
        ...state,
        userNotes: [],
        userNotesLoading: true,
        userNotesPageable: { ...defaultPageable },
        userNotesSearch: { ...defaultSearch },
      };
    case types.GET_USER_NOTES_REQUEST:
      return { ...state, userNotesLoading: true };
    case types.GET_USER_NOTES_SUCCESS:
      return {
        ...state,
        userNotesLoading: false,
        userNotes: payload.data,
        userNotesPageable: payload.pageable,
      };
    case types.GET_USER_NOTES_FAILURE:
      return { ...state, userNotesLoading: false };

    // public notes
    case types.CLEAR_PUBLIC_NOTES:
      return {
        ...state,
        publicNotes: [],
        publicNotesLoading: true,
        publicNotesPageable: { ...defaultPageable },
        publicNotesSearch: { ...defaultSearch },
      };
    case types.GET_PUBLIC_NOTES_REQUEST:
      return { ...state, publicNotesLoading: true };
    case types.GET_PUBLIC_NOTES_SUCCESS:
      return {
        ...state,
        publicNotesLoading: false,
        publicNotes: payload.data,
        publicNotesPageable: payload.pageable,
      };
    case types.GET_PUBLIC_NOTES_FAILURE:
      return { ...state, publicNotesLoading: false };

    // single note
    case types.CLEAR_NOTE:
      return { ...state, note: null, noteLoading: true };
    case types.GET_NOTE_REQUEST:
      return { ...state, noteLoading: true };
    case types.GET_NOTE_SUCCESS:
      return { ...state, noteLoading: false, note: payload };
    case types.GET_NOTE_FAILURE:
      return { ...state, noteLoading: false };

    // selection
    case types.SELECT_NOTE:
      return { ...state, selectedNote: payload };
    case types.CLEAR_SELECTED_NOTE:
      return { ...state, selectedNote: null };

    // user notes pagination
    case types.SET_USER_NOTES_SEARCH:
      return {
        ...state,
        userNotesSearch: { ...state.userNotesSearch, page: 0, search: payload },
      };
    case types.SET_USER_NOTES_PAGE_SIZE:
      return {
        ...state,
        userNotesSearch: { ...state.userNotesSearch, page: 0, size: payload },
      };
    case types.NEXT_USER_NOTES_PAGE:
      return {
        ...state,
        userNotesSearch: { ...state.userNotesSearch, page: state.userNotesSearch.page + 1 },
      };
    case types.PREV_USER_NOTES_PAGE:
      return {
        ...state,
        userNotesSearch: { ...state.userNotesSearch, page: state.userNotesSearch.page - 1 },
      };

    // public notes pagination
    case types.SET_PUBLIC_NOTES_SEARCH:
      return {
        ...state,
        publicNotesSearch: { ...state.publicNotesSearch, page: 0, search: payload },
      };
    case types.SET_PUBLIC_NOTES_PAGE_SIZE:
      return {
        ...state,
        publicNotesSearch: { ...state.publicNotesSearch, page: 0, size: payload },
      };
    case types.NEXT_PUBLIC_NOTES_PAGE:
      return {
        ...state,
        publicNotesSearch: { ...state.publicNotesSearch, page: state.publicNotesSearch.page + 1 },
      };
    case types.PREV_PUBLIC_NOTES_PAGE:
      return {
        ...state,
        publicNotesSearch: { ...state.publicNotesSearch, page: state.publicNotesSearch.page - 1 },
      };

    default:
      return state;
  }
};

export default notesReducer;
